import administracao from './administracao/index'
import almoxarifado from './almoxarifado/index'
import ambulatorio from './ambulatorio/index'
import apac from './apac/index'
import atencaoBasica from './atencao-basica/index'
import bpa from './bpa'
import cadastro from './cadastro'
import exameImagem from './exame-imagem/index'
import exameLaboratorial from './exame-laboratorial/index'
import farmacia from './farmacia/index'
import imunizacao from './imunizacao/index'
import integracao from './integracao'
import manutencao from './manutencao/index'
import parametrizacao from './parametrizacao/index'
import prontoAtendimento from './pronto-atendimento/index'
import raas from './raas/index'
import regulacao from './regulacao'
import transportePaciente from './transporte-paciente/index'

export default baseUrl => {
    baseUrl = `${baseUrl}/exportacao`

    return {
        administracao: administracao(baseUrl),
        almoxarifado: almoxarifado(baseUrl),
        ambulatorio: ambulatorio(baseUrl),
        apac: apac(baseUrl),
        atencaoBasica: atencaoBasica(baseUrl),
        bpa: bpa(baseUrl),
        cadastro: cadastro(baseUrl),
        exameImagem: exameImagem(baseUrl),
        exameLaboratorial: exameLaboratorial(baseUrl),
        farmacia: farmacia(baseUrl),
        imunizacao: imunizacao(baseUrl),
        integracao: integracao(baseUrl),
        manutencao: manutencao(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        prontoAtendimento: prontoAtendimento(baseUrl),
        raas: raas(baseUrl),
        regulacao: regulacao(baseUrl),
        transportePaciente: transportePaciente(baseUrl),
    }
}
